export default __webpack_public_path__ + "static/media/service-1.5221df50.png";